import gsap from 'gsap';

export default function initRooms() {
    const blocks = document.querySelectorAll('[data-component="rooms"]');

    blocks.forEach(block => {
        const slides = block.querySelectorAll('.rooms-block__content');
        const rails = block.querySelectorAll('.images-rail');
        const prevBtn = block.querySelector('.swiper-button-prev');
        const nextBtn = block.querySelector('.swiper-button-next');
        const imagesContainer = block.querySelector('.images-container');

        const totalSlides = slides.length;
        if (totalSlides === 0) return;

        let virtualIndex = totalSlides; // Start at the beginning of the middle block
        let isAnimating = false;

        // Accessibility: hide non-active slides from keyboard/screen readers
        const updateA11y = () => {
            const realIndex = (virtualIndex % totalSlides + totalSlides) % totalSlides;
            slides.forEach((slide, i) => {
                if (i === realIndex) {
                    slide.removeAttribute('inert');
                } else {
                    slide.setAttribute('inert', '');
                }
            });
        };

        // Clone images to create infinite rails
        rails.forEach(rail => {
            const items = Array.from(rail.children);
            // Append two sets of clones
            items.forEach(item => rail.appendChild(item.cloneNode(true)));
            items.forEach(item => rail.appendChild(item.cloneNode(true)));
        });

        const getRailX = (rail, vIndex) => {
            const container = rail.closest('.images-container');
            const itemWidth = container.offsetWidth; // Use the specific container's width

            if (container.classList.contains('images-container--prev')) {
                return -(vIndex - 1) * itemWidth;
            } else if (container.classList.contains('images-container--active')) {
                return -vIndex * itemWidth;
            } else if (container.classList.contains('images-container--next')) {
                return -(vIndex + 1) * itemWidth;
            }
            return 0;
        };


        const updateSlider = (direction = 1) => {
            if (isAnimating) return;
            isAnimating = true;

            const prevSlide = slides[(virtualIndex % totalSlides + totalSlides) % totalSlides];
            virtualIndex += direction;
            const realIndex = (virtualIndex % totalSlides + totalSlides) % totalSlides;
            const nextSlide = slides[realIndex];

            const tl = gsap.timeline({
                onComplete: () => {
                    isAnimating = false;
                    updateA11y();

                    // Infinite wrap check
                    if (virtualIndex >= totalSlides * 2) {
                        virtualIndex -= totalSlides;
                        gsap.set(rails, { x: (i, rail) => getRailX(rail, virtualIndex) });
                    } else if (virtualIndex < totalSlides) {
                        virtualIndex += totalSlides;
                        gsap.set(rails, { x: (i, rail) => getRailX(rail, virtualIndex) });
                    }
                }
            });

            // Animate images
            rails.forEach(rail => {
                tl.to(rail, {
                    x: getRailX(rail, virtualIndex),
                    duration: 1.2,
                    ease: "expo.inOut"
                }, 0);
            });

            // Animate content (fade out old, fade in new with staggers)
            if (prevSlide && nextSlide && prevSlide !== nextSlide) {
                // Elements to animate
                const prevElements = prevSlide.querySelectorAll('.subtitle, .rooms-block__content__title, .rooms-block__content__description');
                const nextElements = nextSlide.querySelectorAll('.subtitle, .rooms-block__content__title, .rooms-block__content__description');

                // Out
                tl.to(prevElements, {
                    opacity: 0,
                    y: -30,
                    stagger: 0.05,
                    duration: 0.5,
                    ease: "power2.in"
                }, 0);

                tl.set(prevSlide, { className: "rooms-block__content rich-text" }, 0.5);
                tl.set(nextSlide, { className: "rooms-block__content rich-text is-active" }, 0.5);

                // In
                tl.fromTo(nextElements, {
                    opacity: 0,
                    y: 30
                }, {
                    opacity: 1,
                    y: 0,
                    stagger: 0.1,
                    duration: 1,
                    ease: "power3.out"
                }, 0.6);
            }
        };

        // Initial state
        const init = () => {
            gsap.set(rails, { x: (i, rail) => getRailX(rail, virtualIndex) });

            slides.forEach((slide) => {
                const elements = slide.querySelectorAll('.subtitle, .rooms-block__content__title, .rooms-block__content__description');
                if (slide.classList.contains('is-active')) {
                    gsap.set(elements, { opacity: 1, y: 0 });
                } else {
                    gsap.set(elements, { opacity: 0, y: 30 });
                }
            });
        };



        init();
        updateA11y();

        nextBtn?.addEventListener('click', () => {
            updateSlider(1);
        });

        prevBtn?.addEventListener('click', () => {
            updateSlider(-1);
        });

        // Swipe support
        let touchStartX = 0;
        let touchEndX = 0;

        block.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        block.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            handleGesture();
        }, { passive: true });

        const handleGesture = () => {
            const diffX = touchEndX - touchStartX;
            if (Math.abs(diffX) > 50) {
                if (diffX > 0) {
                    updateSlider(-1);
                } else {
                    updateSlider(1);
                }
            }
        };

        window.addEventListener('resize', () => {
            init();
        });
    });
}

